<template>
    <div class="myExamGrades">
        <el-row>
            <el-col :span="24">
                <div class="information">
                    <div class="informationCenter">
                        <div class="informationTitle">
                            <Title text="我的成绩" />
                        </div>
                        <div class="elTabs">
                            <div style="text-align: right;margin-bottom: 10px;">
                                <el-button type="primary" @click="scorePrintingClick">打印</el-button>
                            </div>
                            <div class="averageScoreClass">必修课平均分: <span>{{printInfo.avg_score}}</span></div>
                            <div class="informationDiv">
                                <div class="scorePrintingAE-print-box" ref="print-content">
                                    <div v-if="isPrint">
                                        <div class="title">重庆医科大学学业成绩表</div>
                                        <div class="floor-text floor-text1">
                                            <p class="text">
                                                <span class="name">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
                                                <span class="value">{{ printInfo.student_code }}</span>
                                            </p>
                                            <p class="text">
                                                <span class="name">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
                                                <span class="value">{{ printInfo.student_title }}</span>
                                            </p>
                                            <p class="text">
                                                <span class="name">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;制：</span>
                                                <span class="value">{{ printInfo.year }}</span>
                                            </p>
                                        </div>
                                        <div class="floor-text floor-text1">
                                            <p class="text">
                                                <span class="name">院&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系：</span>
                                                <span class="value">{{ printInfo.college_title }}</span>
                                            </p>
                                            <p class="text">
                                                <span class="name">专业名称：</span>
                                                <span class="value">{{ printInfo.pro_title }}</span>
                                            </p>
                                            <p class="text class">
                                                <span class="name">班级名称：</span>
                                                <span class="value">{{ printInfo.class_title }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="table-box">
                                        <!-- border="1" -->
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <th>课程名称</th>
                                                    <th style="width: 8%;">性质</th>
                                                    <th style="width: 10%;">学分</th>
                                                    <th style="width: 15%;">正考总评</th>
                                                    <th style="width: 15%;">补考总评</th>
                                                    <th style="width: 10%;">最终成绩</th>
                                                    <th style="width: 20%;">备注</th>
                                                </tr>
                                            </tbody>
                                            <tbody v-for="(item, key) in parinScoreList" :key="key">
                                                <tr>
                                                    <td class="left" colspan="7">{{yearHandle(key)}}</td>
                                                </tr>
                                                <tr v-for="(item2, index2) in item" :key="index2">
                                                    <td class="left">{{ item2.course_title }}</td>
                                                    <td>必修</td>
                                                    <td>{{ item2.credits }}</td>
                                                    <td>{{ item2.are_score == '-1.00' ? '' : item2.are_score }}</td>
                                                    <td>{{ item2.resit_score == '-1.00' ? '' : item2.resit_score }}</td>
                                                    <td>{{ item2.score == '-1.00' ? '' : item2.score }}</td>
                                                    <td>{{ item2.remark }}</td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <!-- <tr>
                                                    <td class="center" colspan="2">总学分</td>
                                                    <td class="center">{{ printInfo.total_credit }}</td>
                                                    <td class="center">平均成绩</td>
                                                    <td class="center">{{ printInfo.avg_score }}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr> -->
                                                <!-- <tr>
                                                    <td>英语四六级成绩</td>
                                                    <td colspan="6"></td>
                                                </tr> -->
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="isPrint" class="bot">
                                        <p class="text">
                                            <span class="name">必修课平均分：</span>
                                            <span class="value">{{ printInfo.avg_score }}</span>
                                        </p>
                                        <p class="text">
                                            <span class="value">重庆医科大学继续教育学院</span>
                                        </p>
                                        <!-- <p class="text">
                                            <span class="name">平均成绩：</span>
                                            <span class="value">{{ printInfo.avg_score }}</span>
                                        </p>
                                        <p class="text">
                                            <span class="name">总成绩：</span>
                                            <span class="value">{{ printInfo.total_score }}</span>
                                        </p> -->
                                        <p class="text">
                                            <span class="name">时间：</span>
                                            <span class="value">{{ printInfo.print_time }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="elTabs">
                            <div class="averageScoreClass">平均分: <span v-if="disGeneralDataList&&disGeneralDataList.acg_score">{{disGeneralDataList.acg_score}}</span></div>
                            <div class="informationDiv">
                                <el-table style="width:99%" slot="list" :data="disGeneralDataList.course_data"
                                    headerRowClassName="uni-primary-table-header" stripe border>
                                    <el-table-column prop="start_year" align="center" label="学年"></el-table-column>
                                    <el-table-column prop="course_semester" align="center" label="学期"></el-table-column>
                                    <el-table-column prop="course_title_copy" align="center" label="课程">
                                    </el-table-column>
                                    <el-table-column prop="score" align="center" label="最终成绩"></el-table-column>
                                </el-table>
                            </div>

                        </div> -->
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { myStudentScore, courseReview } from "@/api/basic";
import { downLoadFiles, getCurrentTime } from "@/utils/func";

export default {
    name: "myExamGrades",
    data() {
        return {
            activeName: "examination",
            // dataList: [],
            // disGeneralDataList: [],
            // exam_status: [
            //     "-",
            //     "报名待审核",
            //     "缴费审核失败",
            //     "待考试",
            //     "阅卷中",
            //     "缺考",
            //     "考试完成",
            // ],

            isPrint: false,
            printInfo: {},  //打印信息
            parinScoreList: null,  //打印列表信息
        };
    },
    mounted() {
        this.getDisGeneralData();
    },
    methods: {
        // 打印
        scorePrintingClick(){
            this.isPrint = true;
            this.$nextTick(() => {
                const printEl = this.$refs['print-content'];
                const cloneNodeEl = printEl.cloneNode(true);  //克隆元素
                document.body.appendChild(cloneNodeEl);
                // document.getElementById('print-content-clone')
                this.$print(cloneNodeEl);  //打印
                cloneNodeEl.remove();  //删除克隆元素
                this.isPrint = false;
            });
        },
        // 学年学期 处理
        yearHandle(v){
            const list = v.split('-');
            return `${list[0]} 年 ${list[1]}学期`;
        },
        // 非统考成绩
        async getDisGeneralData() {
            const { result } = await myStudentScore();
            if (result) {
                // this.disGeneralDataList = result;
                const {info, list} = result;
                this.printInfo = info;
                this.printInfo.print_time = getCurrentTime(true, 'Y年M月D日');
                this.parinScoreList = list; 
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.information {
    min-height: $contentH;
    padding: 20px 20px 0 20px;
    /deep/ .el-table .cell {
        padding: 5px 0;
    }
}
.informationCenter {
    width: 100%;
    min-height: inherit;
    background-color: #fff;
    padding-bottom: 20px;
}
.informationTitle {
    display: flex;
    align-items: center;
}
.elTabs {
    padding: 0 20px;
}
.informationTitle span {
    display: inline-block;
    width: 4px;
    height: 23px;
    background-color: #1459a6;
}
.informationTitle {
    padding-left: 20px;
}
.informationDiv {
    width: 100%;
    margin-top: 28px;
}

.link-btn {
    height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.averageScoreClass{
   width: 100%;
   text-align: right;
//    padding-right: 50px;
}

.scorePrintingAE-print-box{
    .title{
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .floor-text{
        width: 100%;
        display: flex;
        margin-top: 10px;
        color: #333;
        // .text{
        //     width: 32%;
        //     margin-right: 1%;
        // }
        .text{
            display: flex;
            flex-shrink: 0;
            font-size: 14px;
            .name{
                flex-shrink: 0;
            }
            .value{
            }
            &:nth-child(1){
                width: 40%;
                margin-right: 2%;
            }
            &.class{
                flex-shrink: 1;
            }
        }
        &.floor-text1{
            .text {
                &:nth-child(2){
                    width: 30%;
                    margin-right: 2%;
                }
            }
        }
    }
    .table-box{
        margin-top: 20px;
        table, tbody, th, td {
            border: 1px solid #999;
            border-collapse: collapse;
        }
        td,th{
            font-size: 14px;
            padding: 5px;
            text-align: center;
            vertical-align: middle;  //垂直居中
            &.left{
                text-align: left;
            }
        }
        .table{
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
        }
    }
    .bot{
        margin-top: 20px;
        // text-align: right;
        display: flex;
        justify-content: space-between;
        color: #333;
        font-size: 14px;
        // .text{
        //     display: inline-block;
        //     margin-left: 50px;
        // }
    }
}
@media print {
    .scorePrintingAE-print-box{
        width: 980px;
        // width: 100%;
        padding: 24px 30px 10px 30px;
        // margin-top: -15vh;
        // width: 960px;
        // padding: 10px;
        // position: fixed;
        // top: 0;
        // left: 0;
        // .bot{
        //     margin-right: 20px;
        // }
    }
}

</style>
